import React, { useState } from 'react';
import cn from 'classnames';
import { calculateTaskPosition, formatTimeOnly } from './Utils';
import { TASK_DAY_OFF_TYPE } from "./Constants";

const Task = ({ task, onTaskClick }) => {
  const { top, height } = calculateTaskPosition(task);
  const minutesDifference = Math.abs(task.end - task.start) / (1000 * 60);
  const shortTime = minutesDifference <= 60;
  const dayOff = task.kind === TASK_DAY_OFF_TYPE;
  return (
    <div
      className={cn('task', { '-loading': task.loading, '-dayOff': dayOff })}
      style={{ top: `${top}px`, height: `${height}px` }}
      onClick={() => onTaskClick(task)}
      onMouseDown={e => e.stopPropagation()}
      onMouseMove={e => e.stopPropagation()}
      onMouseUp={e => e.stopPropagation()}
    >
      {!dayOff && shortTime && (
        formatTimeOnly(task.start)
      )}
      {!dayOff && !shortTime && (
        `${formatTimeOnly(task.start)} - ${formatTimeOnly(task.end)}`
      )}
      {dayOff && `day off`}
    </div>
  );
};
export default Task;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/Task.js